<template>
  <b-row class="match-height">
    <b-col cols="12">
      <b-row>
        <b-col
          class="col-12 col-md-3"
        >
          <b-row>
            <b-col
              v-show="!details"
              class="col-12"
            >
              <card-analytic-total-users
                title="Active Users"
                :data-object="mainQuery"
                :on-progress="mainQueryOnProgress"
              />
            </b-col>
            <b-col
              v-show="!details"
              class="col-12"
            >
              <card-analytics-videos-live
                title="Videos"
                :data-object="videoStatistics"
                :on-progress="videoStatisticsOnProgress"
              />
            </b-col>
            <b-col class="col-12">
              <page-filter :filters="getFilterObject()" />
            </b-col>
          </b-row>
        </b-col>
        <b-col
          v-show="!details"
          class="col-12 col-md-9"
        >
          <b-row>
            <b-col
              cols="12"
            >
              <apex-line-area-chart
                v-if="!isMobile()"
                ref="apexChart"
                :main="mainQuery"
                :series1="graphMinutely7DayAgo"
                :series2="graphMinutelyYesterday"
                :series3="graphMinutelyToday"
                :avg-statistics="pageAVGStatistics"
                :avg-statistics-on-progress="pageAVGStatisticsOnProgress"
                :re-render="apexRender"
                :on-progress="graphMinutelyTodayOnProgress"
                :skin-mode="this.skinMode"
              />
              <b-card
                v-if="isMobile()"
              >
                <card-analytics-avg-page-statistics
                  :data-object="pageAVGStatistics"
                  :on-progress="pageAVGStatisticsOnProgress"
                />
              </b-card>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <page-view-table
                :page-views="mainQuery"
                :on-progress="mainQueryOnProgress"
                :details-page-url="detailsPageUrl"
                :page-avg="pageAVGStatistics"
                :by-content-filter="byContentFilter"
                @openDetails="openDetails"
              />
            </b-col>
          </b-row>
        </b-col>
        <b-col
          v-show="details"
          class="col-12 col-md-9"
        >
          <news-details
            :details="details"
            :page-avg="pageAvgData"
            :on-progress="mainQueryOnProgress"
            @closeDetails="closeDetails"
          />
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {
    BCard,
    BRow,
    BCol,
} from 'bootstrap-vue'

import usAppConfig from '@core/app-config/useAppConfig'
import ApexLineAreaChart from '@/views/charts/apex/ApexLineAreaChart.vue'
import CardAnalyticTotalUsers from '@/views/card/card-analytic/CardAnalyticTotalUsers.vue'
import PageViewTable from '@/views/components/tables/PageViewTable.vue'
import { executeQuery, resetQueries, resetQuery } from '@/coreApi/coreApiDataset'
import coreApiDataIndex from '@/coreApi/coreApiDataIndex'
import { getCoreApiData, getCoreApiDataOnProgress } from '@/coreApi/coreApi'
import PageFilter from '@/views/components/filters/PageFilter.vue'
import CardAnalyticsAvgPageStatistics from '@/views/card/card-analytic/CardAnalyticsAvgPageStatistics.vue'
import { getProjectCoreProjectId, getProjectFilterObject } from '@/coreApi/filters/coreApiFilterHelper'
import NewsDetails from '@/views/components/details/NewsDetails.vue'
import CardAnalyticsVideosLive from '@/views/card/card-analytic/CardAnalyticsVideosLive.vue'
import { coreApiDetailFilterObject } from '@/coreApi/filters/coreApiDetailFilter'

export default {
    components: {
        NewsDetails,
        CardAnalyticsAvgPageStatistics,
        BCard,
        BRow,
        BCol,
        ApexLineAreaChart,
        CardAnalyticTotalUsers,
        PageViewTable,
        PageFilter,
        CardAnalyticsVideosLive,
    },
    data() {
        return {
            details: null,
            detailsPageUrl: null,
            pageAvgData: {},
            projectId: null,
            filter: null,
            apexRender: 0,
            byContentFilter: true,
        }
    },
    watch: {
        $route() {
            this.initQueries()
            this.intiDetails()
        },
    },
    created() {
        this.initQueries()
        this.intiDetails()
    },
    methods: {
        isMobile() {
            return window.innerWidth < 768
        },
        initQueries() {
            const projectFilterObject = getProjectFilterObject()
            const pageFilter = projectFilterObject.getFilterQueryObject()
            pageFilter.push({ key: 'fromAtSecond', value: 300 })
            const filterKey = JSON.stringify(pageFilter)

            if (this.projectId !== getProjectCoreProjectId() || this.filter !== filterKey) {
                this.projectId = getProjectCoreProjectId()
                this.filter = filterKey
                this.query(getProjectCoreProjectId(), pageFilter)
            }
        },
        getFilterObject() {
            const projectFilterObject = getProjectFilterObject()
            return projectFilterObject.getFilterList()
        },
        query(projectId, pageFilter) {
            if (['bl8372p22-kd', 'bl8372p22-tv', 'bl8372p22-hs', 'bl8372p22-ms', 'bl8372p22-cns', 'bl8372p22-psts', 'bl8372p22-gvs', 'bl8372p22-rd', 'bl2ok5med65lk2-muo'].includes(projectId)) {
                this.byContentFilter = false
            } else {
                this.byContentFilter = true
            }
            // !!!----- OLD VERSION / NOT IN USE --> Platinum Data Active Users Statistics b1dac0e3a5ef4e8 -----!!! //
            // Platinum Data Active Users Statistics V2 n53221a99c4c3

            let projectIdBase = projectId
            if (projectIdBase.indexOf('-') > -1) {
                projectIdBase = projectIdBase.slice(0, projectIdBase.indexOf('-'))
            }
            let secim = false
            if (projectId === 'bl8372p22-hs') {
                projectIdBase = 'bl1767ftdlk224'
                pageFilter.push({ key: 'projectId', value: 'bl1767ftdlk224' })
                pageFilter.push({ key: 'page_domains', value: 'secim.hurriyet.com.tr' })
                secim = true
            } else if (projectId === 'bl8372p22-ms') {
                projectIdBase = 'bl2ok5med65lk2'
                pageFilter.push({ key: 'projectId', value: 'bl2ok5med65lk2' })
                pageFilter.push({ key: 'page_domains', value: 'secim.milliyet.com.tr' })
                secim = true
            } else if (projectId === 'bl8372p22-cns') {
                projectIdBase = 'bl8372p22'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl8372p22-cn',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'secim.cnnturk.com',
                })
                secim = true
            } else if (projectId === 'bl8372p22-psts') {
                projectIdBase = 'bl8372p22'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl8372p22-ps',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'secim.posta.com.tr',
                })
                secim = true
            } else if (projectId === 'bl8372p22-gvs') {
                projectIdBase = 'bl8372p22'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl8372p22-gv',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'secim.gazetevatan.com',
                })
                secim = true
            } else if (projectId === 'bl1767ftdlk224-ho') {
                projectIdBase = 'bl1767ftdlk224'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl1767ftdlk224',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'www.hurriyet.com.tr',
                })
            } else if (projectId === 'bl1767ftdlk224-hbo') {
                projectIdBase = 'bl1767ftdlk224'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl1767ftdlk224',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'bigpara.hurriyet.com.tr,mbigpara.hurriyet.com.tr',
                })
            } else if (projectId === 'bl2ok5med65lk2-mo') {
                projectIdBase = 'bl2ok5med65lk2'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl2ok5med65lk2',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'www.milliyet.com.tr,m.milliyet.com.tr',
                })
            } else if (projectId === 'bl2ok5med65lk2-muo') {
                projectIdBase = 'bl2ok5med65lk2'
                pageFilter.push({
                    key: 'projectId',
                    value: 'bl2ok5med65lk2',
                })
                pageFilter.push({
                    key: 'page_domains',
                    value: 'uzmanpara.milliyet.com.tr,uzmanparam.milliyet.com.tr',
                })
            } else {
                pageFilter.push({
                    key: 'projectId',
                    value: projectId,
                })
            }

            executeQuery(
                coreApiDataIndex.d1,
                {
                    timeout: 22,
                    request_nodes: [
                        {
                            project_id: projectIdBase,
                            alias: 'livePageViewStatistics',
                            options: [
                                {
                                    alias: 'livePageViewStatistics',
                                    return_id: 'statistics',
                                    offset: 0,
                                    limit: 1,
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'pvFiltered',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'pageViewFilter30Min',
                                    filter_values: pageFilter,
                                },
                            ],
                        },
                        {
                            project_id: projectIdBase,
                            alias: 'livePageViewDetails',
                            options: [
                                {
                                    alias: 'livePageViewDetails',
                                    return_id: 'pageViews',
                                    offset: 0,
                                    limit: 200,
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'pvFiltered',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'pageViewFilter30Min',
                                    filter_values: pageFilter,
                                },
                            ],
                        },
                    ],

                },
                22000,
            )

            if (!secim) {
                // Live Video Stats
                executeQuery(
                    coreApiDataIndex.d7,
                    {
                        timeout: 60,
                        request_nodes: [
                            {
                                project_id: projectIdBase,
                                alias: 'liveVideoDetails',
                                options: [
                                    {
                                        alias: 'liveVideoDetails',
                                        return_id: 'videoStatistics',
                                        filter_values: pageFilter,
                                        offset: 0,
                                        limit: 3,
                                    },
                                ],
                            },
                        ],
                    },
                    60000,
                )
            } else {
                resetQuery(coreApiDataIndex.d7)
            }

            if (!this.isMobile()) {
                // Platinum Data Daily Graph Minutely Page View Count Today b1u762e5db36221
                const pageFilterRealtime = [...pageFilter]
                pageFilterRealtime.push({
                    key: 'realtime',
                    value: 1,
                })
                executeQuery(
                    coreApiDataIndex.d2,
                    {
                        timeout: 600,
                        request_nodes: [
                            {
                                project_id: projectIdBase,
                                alias: 'dailyPageViewGraphPVCountMinutely',
                                options: [
                                    {
                                        alias: 'dailyPageViewGraphPVCountMinutely',
                                        return_id: 'today',
                                        offset: 0,
                                        limit: 1440,
                                        filter_values: pageFilterRealtime,
                                    },
                                    {
                                        alias: 'pageView',
                                        filter_date_indicator: {
                                            type: 'daily',
                                            skip: 0,
                                            take: 1,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    600000,
                )

                // Platinum Data Daily Graph Minutely Page View Count b1c4b4216d7f3d6
                executeQuery(
                    coreApiDataIndex.d3,
                    {
                        timeout: 1800,
                        request_nodes: [
                            {
                                project_id: projectIdBase,
                                alias: 'dailyPageViewGraphPVCountMinutely',
                                options: [
                                    {
                                        alias: 'dailyPageViewGraphPVCountMinutely',
                                        return_id: 'yesterday',
                                        offset: 0,
                                        limit: 1440,
                                        filter_values: pageFilter,
                                    },
                                    {
                                        alias: 'pageView',
                                        filter_date_indicator: {
                                            type: 'daily',
                                            skip: 1,
                                            take: 1,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    1800000,
                )

                // Platinum Data Daily Graph Minutely Page View Count b1c4b4216d7f3d6
                executeQuery(
                    coreApiDataIndex.d4,
                    {
                        timeout: 1800,
                        request_nodes: [
                            {
                                project_id: projectIdBase,
                                alias: 'dailyPageViewGraphPVCountMinutely',
                                options: [
                                    {
                                        alias: 'dailyPageViewGraphPVCountMinutely',
                                        return_id: 'sevenDaysAgo',
                                        offset: 0,
                                        limit: 1440,
                                        filter_values: pageFilter,
                                    },
                                    {
                                        alias: 'pageView',
                                        filter_date_indicator: {
                                            type: 'daily',
                                            skip: 7,
                                            take: 1,
                                        },
                                    },
                                ],
                            },
                        ],
                    },
                    1800000,
                )
            }
            // !!!----- OLD VERSION / NOT IN USE --> Platinum Data Active Users Page Views b1jc36e3b7c570b -----!!! //
            // Platinum Data Active Users Page Views V2 yf178020e86b0

            // Platinum Data Page AVG Statistics b1s373148b52303
            executeQuery(
                coreApiDataIndex.d6,
                {
                    timeout: 304,
                    request_nodes: [
                        {
                            project_id: projectIdBase,
                            alias: 'dailyPageViewStatistics',
                            options: [
                                {
                                    alias: 'dailyPageViewStatistics',
                                    return_id: 'statistics',
                                    offset: 0,
                                    limit: 1,
                                },
                                {
                                    alias: 'pageView',
                                    filter_values: pageFilter,
                                },
                                {
                                    alias: 'cumulativePageView',
                                    filter_date_indicator: {
                                        type: 'daily',
                                        skip: 0,
                                        take: 1,
                                    },
                                },
                            ],
                        },
                    ],
                },
                300000,
            )
        },
        intiDetails() {
            const projectFilterObject = getProjectFilterObject()
            const detailsObject = projectFilterObject.getFilterDetails()
            if (detailsObject) {
                if (
                    !this.details
                    && detailsObject.pageUrl
                ) {
                    this.detailsPageUrl = detailsObject.pageUrl
                }
            } else {
                this.closeDetails()
            }
        },
        openDetails(obj) {
            if (obj.details && obj.details.pageUrl) {
                const filters = { details: { pageUrl: obj.details.pageUrl } }
                const newPath = coreApiDetailFilterObject.getFilterUrl(filters)
                if (newPath !== this.$route.fullPath) {
                    this.$router.push(newPath)
                }
                this.detailsPageUrl = obj.details.pageUrl
            } else {
                this.detailsPageUrl = null
            }
            this.details = obj.details
            this.pageAvgData = obj.pageAvgData
        },
        closeDetails() {
            const filters = { details: null }
            const newPath = coreApiDetailFilterObject.getFilterUrl(filters)
            if (newPath !== this.$route.fullPath) {
                this.$router.push(newPath)
            }
            this.detailsPageUrl = null
            this.details = null
            this.pageAvgData = null
            this.apexRender += 1
        },
    },
    setup() {
        return {
            mainQuery: getCoreApiData(coreApiDataIndex.d1),
            mainQueryOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d1),
            graphMinutelyToday: getCoreApiData(coreApiDataIndex.d2),
            graphMinutelyTodayOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d2),
            graphMinutelyYesterday: getCoreApiData(coreApiDataIndex.d3),
            graphMinutelyYesterdayOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d3),
            graphMinutely7DayAgo: getCoreApiData(coreApiDataIndex.d4),
            graphMinutely7DayAgoOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d4),
            pageAVGStatistics: getCoreApiData(coreApiDataIndex.d6),
            pageAVGStatisticsOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d6),
            videoStatistics: getCoreApiData(coreApiDataIndex.d7),
            videoStatisticsOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d7),
            skinMode: usAppConfig().skin,
        }
    },
    beforeRouteLeave(to, from, next) {
        resetQueries()
        next()
    },
}
</script>

<style>

</style>
